import { CACHE_TIME, STALE_TIME } from '@/constants';
import { trpc } from '@/data-loaders';

export const useUnitWorkloadCampuses = (unitWorkloadId: number, year: number) => {
  return trpc.getUnitWorkloadCampuses.useQuery(
    { unitWorkloadId, year },
    {
      retry: false,
      cacheTime: CACHE_TIME,
      staleTime: STALE_TIME,
      enabled: !!unitWorkloadId && !!year,
    },
  );
};
